<template>
  <div class="a-picker-view-wrapper">
    <div class="a-picker-view">
      <div v-for="(range, i) in ranges" :key="i" class="a-picker-view-column">
        <picker-view-column
          :range="range" :rkey="rkey" :value="value[i]" :force="force[i]"
          @change="onColumnChange(i, $event)"
          @touchstart="onTouchstart(i)"
        ></picker-view-column>
      </div>
    </div>
    <div class="a-picker-view-cover"></div>
  </div>
</template>

<script>
  import PickerViewColumn from './picker-view-column.vue';

  export default {
    components: {
      'picker-view-column': PickerViewColumn
    },

    props: {
      ranges: Array,
      rkey: String,
      value: Array,
      force: Array
    },

    methods: {
      onTouchstart(idx) {
        this.$emit('touchstart', {
          detail: {
            column: idx
          }
        });
      },

      onColumnChange(idx, e) {
        this.$emit('columnchange', {
          detail: {
            column: idx,
            value: e.value
          }
        });
      }
    }
  };
</script>

<style lang="scss">
  $VIEW-HEIGHT: 196px;
  $ITEM-HEIGHT: 28px;

  .a-picker-view-wrapper {
    position: relative;
    padding: 10px 0;
    background: #fff;
  }

  .a-picker-view {
    display: flex;
    height: $VIEW-HEIGHT;
    overflow: hidden;
  }

  .a-picker-view-cover {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    transform: translate3d(0,0,0); /* 因为外层有动画升上来，这个绝对定位的元素在iOS上有延迟（动画结束才会显示），所以这里使用transform */
    background-image: linear-gradient(0deg, rgba(255,255,255,0.98), rgba(255,255,255,0.65) 93px, transparent 94px, transparent 122px, rgba(255,255,255,0.65) 123px, rgba(255,255,255,0.98));

    &:after {
      content: "";
      display: block;
      position: absolute;
      top: 93px;
      height: $ITEM-HEIGHT;
      width: 100%;
      border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
    }
  }

  .a-picker-view-column {
    width: 0;
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/ui/base/components/picker-view.vue